/**
 * 主力持仓
 */
import React, { useState } from "react"
import { quote_item_name, single_quote } from "../../quotedata/index"
import { mpSort } from "../../utils"

export function MainHoldings(props: { data: any }) {
  let amtNetMax = ""
  if (!props.data || props.data == "-") {
    return <></>
  }

  const holdings = eval(props.data)
  if (holdings.length >= 1) {
    let arr: any = []
    holdings.map((item: any) => {
      arr.push(Math.abs(item.mainNetAmt))
    })
    mpSort(arr)
    amtNetMax = arr[arr.length - 1]
    holdings.reverse()
  }

  return (
    <div className="pk-container">
      <p className="title_p">最近五日主力增减持仓(万元)</p>
      <div className="canvas_pic canvas_pic2">
        <div className="up_div">
          <ul className="up_ul">
            {holdings.map((item: any,index:number) => {
              return single_quote[quote_item_name.流入](item, amtNetMax,index).element
            })}
          </ul>
        </div>
        <div className="down_div">
          <ul className="down_ul">
            {holdings.map((item: any,index:number) => {
              return single_quote[quote_item_name.流出](item, amtNetMax,index).element
            })}
          </ul>
        </div>
        <div className="date_div">
          <ul className="date_ul">
            {holdings.map((item: any,index:number) => {
              return <li key={index}>{item.date.substring(5)}</li>
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}
